import DocumentReviewApi from '../../../../services/api/documentReviewApi'

/* Service class used to perform api calls for document review operations */
class DocumentReviewService {
    constructor() {
        this.api = DocumentReviewApi.create();
    }

    /**
     * Attempts to complete the document review workflow task for this ticket
     * @param {any} ticketId
     * @param {any} payload
     */
    async completeDocumentReviewTask(ticketId, payload) {
        var response = await this.api.completeDocumentReviewTask(ticketId, payload)
        if (response && response.ok) {
            return response.data;
        }

        return 0;
    }

    /**
     * Attempts to update the document review workflow task for this ticket
     * @param {any} ticketId
     * @param {any} payload
     */
    async updateDocumentReviewTask(ticketId, payload) {
        var response = await this.api.updateDocumentReviewTask(ticketId, payload)
        if (response && response.ok) {
            return response.data;
        }

        return 0;
    }

    async resetSignaturePage(ticketId, workflowTask) {
        var status = true;
        if (!this._isResetting) {
            this._isResetting = true;
            try {
                var response = await this.api.resetSignaturePage(ticketId, workflowTask);
                return response?.ok;
            } catch (ex) {
                status = false;
            } finally {
                this._isResetting = false;
            }  
        }

        return status;        
    }
}

const documentReviewService = new DocumentReviewService();
export default documentReviewService;